import sileo from 'sileo';

const MinimalJobOffer = new sileo.Model('hqzen', 'job-offer-minimal');
const ApplicantJobOffer = new sileo.Model('hqzen', 'job-offer');
const ApplicantProfile = new sileo.Model('applybpo', 'applicant-profile');
const PersonalBoardCardDetails = new sileo.Model('board', 'personal-board-card-details');
const EmployeeRequestEmploymentUnblock = new sileo.Model('bposeats', 'employee-request-employment-unblock');
const NavbarPersonalBoard = new sileo.Model('board', 'navbar-personal-board');
const PersonalCardSubtask = new sileo.Model('board', 'personal-subtask');
const PersonalDisplayCard = new sileo.Model('board', 'personal-board-card');
const PersonalBoardCard = new sileo.Model('board', 'personal-board-close-card');
const PersonalCard = new sileo.Model('hqzen', 'personal-card');

const state = {
    jobOffers: [],
    jobOfferError: '',
    applicantProfile: {},
    jobOffer: {},
    selectedGoalMilestones: [],
    selectedGoalDate: '',
    selectedGoalStartDate: '',
    selectedGoalEndDate: '',
};

const getters = {
    jobOffers: state => state.jobOffers,
    jobOfferError: state => state.jobOfferError,
    applicantProfile: state => state.applicantProfile
};

const mutations = {
    setJobOffers: (state, payload) => {
        state.jobOffers = [...payload];
    },
    setJobOffer: (state, payload) => {
        state.jobOffer = { ...payload };
    },
    setJobOfferError: (state, payload) => {
        state.jobOfferError = payload;
    },
    updateApplicant: (state, payload) => {
        state.applicantProfile = { ...payload };
    },
    setSelectedGoalMilestone(state, data) {
        state.selectedGoalMilestones = data;
    },
    setSelectedGoalDate(state, data) {
        state.selectedGoalDate = data;
    },
    setSelectedGoalStartDate(state, data) {
        state.selectedGoalStartDate = data;
    },
    setSelectedGoalEndDate(state, data) {
        state.selectedGoalEndDate = data;
    }
};

const actions = {
    fetchJobOffers({ commit }, applicantPk) {
        return MinimalJobOffer.objects.filter({ applicantId: applicantPk })
            .then(response => {
                commit('setJobOffers', response);
                return response;
            }).catch(error => {
                console.error(error);
            });
    },

    getApplicantJobOffer({ commit }, jobOfferId) {
        return ApplicantJobOffer.objects.get(jobOfferId)
            .then(response => {
                commit('setJobOffer', response);
            }).catch(error => {
                console.error(error);
            });
    },

    async fetchApplicant(context, user_pk) {
        return await ApplicantProfile.objects.get(user_pk).then(
            data => {
                context.commit('updateApplicant', data);
                return data;
            }
        );
    },

    requestEmploymentUnblock(context, payload) {
        const filterArgs = { pk: payload.pk };
        return EmployeeRequestEmploymentUnblock.objects.update(filterArgs, payload);
    },

    fetchPersonalBoards(context, filters) {
        return NavbarPersonalBoard.objects.filter(filters).then(data => {
            data.addExistingBoards = !filters.resetBoards;
            context.commit('board/setBoards', data, { root: true });
            return data.objects;
        }).catch(e => {
            console.error('Error fetching boards', e);
            return [];
        });
    },

    async createPersonalCardSubtask(context, data) {
        const form = new FormData();

        for (let field in data) {
            form.append(field, data[field]);
        }

        return await PersonalCardSubtask.objects.create(form);
    },

    async fetchPersonalCardSubtasks(context, filters) {
        return await PersonalCardSubtask.objects.filter(filters);
    },

    async updatePersonalCardSubtask(context, data) {
        const form = new FormData();
        let pk = data.pk;

        for (let field in data) {
            form.append(field, data[field]);
        }

        return PersonalCardSubtask.objects.update({ 'pk': pk }, form);
    },

    deletePersonalCardSubtask(context, filters) {
        return PersonalCardSubtask.objects.delete(filters);
    },

    fetchPersonalCards(context, data) {
        return PersonalDisplayCard.objects.filter(data);
    },

    fetchPersonalClosedCards(_, filters) {
        return PersonalBoardCard.objects.filter(filters);
    },

    getCardDetails(context, { pk, routeName }) {
        return PersonalBoardCardDetails.objects.get(pk);
    },

    async createCard(context, { data, routeName }) {
        let form = new FormData();

        for (let key of Object.keys(data)) {
            form.append(key, data[key]);
        }

        return await PersonalBoardCardDetails.objects.create(form);
    },

    editCardDetails(context, { data, routeName }) {
        let form = new FormData();
        let filters = { pk: data.pk };

        for (let key of Object.keys(data)) {
            form.append(key, data[key]);
        }

        return PersonalBoardCardDetails.objects.update(filters, form);
    },

    createPersonalMilestoneCard(context, data) {
        let form = new FormData();

        for (let key of Object.keys(data)) {
            form.append(key, data[key]);
        }

        return PersonalCard.objects.create(form);
    },


};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
